<template>
  <div style="width: 1880px;margin: 0 auto;">
    <div class="loading_timer">
      <div>
        <div>{{this.countDown}}</div>
        <div>
          <i class="el-icon-loading"></i>正在分析作文，稍后将进入作文批改页面！
        </div>
      </div>
    </div>
    <!-- 导航栏 -->
    <div style="width: 100%;height:61px;background: #000;">
      <div style="width: 1730px;height: 97px; margin: 0 auto;">
        <Header
          v-if="this.identity !== ''"
          :activeIndex="activeIndex"
          :userName="userName"
          :identity="identity"
          :teacherGroup="teacherGroup"
          :role="role"
        />
      </div>
    </div>
    <div class="page">
      <div class="container-fluid">
        <el-row>
          <el-col :span="9">
            <div>
              <div class="card-header">
                <h3>原图</h3>
                <div>图片识别并编辑仅有一次机会，请仔细核对。</div>
              </div>
              <div class="frame">
                  <el-image 
                    :src="imageList[0]" 
                    :preview-src-list="imageList"
                    style="width: 550px;height:550px;margin: 55px 150px;"
                  />
              </div>
            </div>
          </el-col>
          <el-col :span="3">
            <div style="border: 1px solid #ccc;border-left:0;border-top:0;height:42.5px;width:100%;"></div>
            <div class="middle_cover">
              <div class="move_trans move_1 trans_1"></div>  
              <div class="move_trans move_1 trans_2"></div>              
              <div class="move_trans move_2 trans_1"></div>
              <div class="move_trans move_2 trans_2"></div>              
              <div class="move_trans move_3 trans_1"></div>
              <div class="move_trans move_3 trans_2"></div>              
              <div class="move_trans move_4 trans_1"></div>
              <div class="move_trans move_4 trans_2"></div>              
              <div class="move_trans move_5 trans_1"></div>
              <div class="move_trans move_5 trans_2"></div>              
              <div class="move_trans move_6 trans_1"></div>
              <div class="move_trans move_6 trans_2"></div>              
              <div class="move_trans move_7 trans_1"></div>
              <div class="move_trans move_7 trans_2"></div>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <div class="card-header">
                <h3>文本</h3>
                <div>您需要核对并纠正识别错误的部分</div>
              </div>
              <div class="card_text" @keydown.stop>
                <el-input
                  type="textarea"
                  resize="none"
                  :rows="31"
                  maxlength="2000"
                  placeholder="请输入内容"
                  v-model="data.text"
                >
                </el-input>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="btn_group">
          <el-button type="primary" @click="submitForm(1)" class="btn btn_left">
            暂存
          </el-button>
          <el-button type="primary" @click="submitForm(0)" class="btn">
            提交
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { home } from "@/api";
import axios from "axios";
//引入token解析包 jwt-decode
import jwt_decode from "jwt-decode";
// 引入header组件
import Header from "./header.vue";
export default {
  data() {
    return {
      role: 2,
      activeIndex: "",
      identity: "",
      teacherGroup: 0,
      userName: "",
      title: "",
      grade: "",
      data: {
        id: 0,
        temporary: 1, //1--暂存  0--提交
        // resultcode: 0, //1--不可识别  0--可识别
        text: "", //不可识别的原因 或者 识别的内容
      },
      deadline: "",
      timenow: "",
      countDown: 10, //倒计时
      imageList: [], //保存后台传过来的图片信息
      time: "", //获取后台传过来的截止日期
      mode: 0, //确定是从筛选还是代办进入该页面  0---从筛选页面进入   1---从待办事项进入
      baseUrl: "", //匹配后台地址
      degrees: 0
    };
  },
  components: {
    Header,
  },
  created() {
    this.baseUrl = this.GLOBAL.BASE_URL;
  },
  mounted() {
    this.init();
  },
  methods: {
    // 页面初始化接口
    init() {
      if (localStorage.getItem("token")) {
        // 获取当前账号的角色信息
        this.role = Number(localStorage.getItem("role"));
        let token = jwt_decode(localStorage.getItem("token"));
        // 获取用户信息（用户名和用户身份）
        this.identity = token.identity;
        this.userName = token.nickname;
        this.teacherGroup = token.teacher_group;
        // 清空数组
        this.imageList = [];
        //得到页面跳转带过来的标题，班级，图片id
        let res = this.$route.query;
        this.activeIndex = res.activeIndex;
        this.data.id = Number(res.id);
        // this.title = res.title;
        // this.grade = res.grade;
        // this.mode = res.mode;
        home
          .ocrInitialize({ id: this.data.id, mode: 2 })
          .then((res) => {
            if (res.data && res.data.retcode === 0) {
              this.deadline = res.data.deadline;
              this.timenow = res.data.timenow;
              let arr = res.data.data.img_url; //获取后端的图片数据(是相对路径)
              arr.map((item) => {
                this.imageList.push(item);
              });
              this.title = res.data.title;
              this.data.text = res.data.data.essay_text_raw;
            } else if (res.data && res.data.retcode === 1) {
              alert("登录状态已过期，请重新登录");
              this.clearCache();
            } else {
              alert(res.data.retmsg);
              this.$router.push({ path: "/tasks" });
            }
            this.deadline = "";
            this.timenow = "";
          })
          .catch((err) => {
            console.log("失败", err);
          });
      } else {
        setTimeout(() => {
          alert("未登录，请进行登录");
          this.$router.push({ path: "/login" });
        }, 500);
      }
    },
    //倒计时函数
    timeDown() {
      if(this.countDown > 0){
        let t1 = setInterval(() => {
          this.countDown -= 1
          // 倒计时归零时清除定时器
          if (this.countDown === 0) {
            clearInterval(t1);
            this.countDown = 0;
            this.handleCorrect()
          }
        }, 1000);
      }
    },
    // 查询该作文是否完成分析(完成---可跳转到作文批改页面)
    handleCorrect() {
      home.check({ id: this.data.id, mode: 2 }).then(res => {
        if (res.data.retcode === 0) {
          // 判断作文是否还在分析阶段
          if(res.data.data.state === 'analyzing'){
            this.$confirm('作文分析未完成, 是否继续等待?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.countDown = 10;
              this.timeDown();
            }).catch(() => {
              this.$router.push({ path: "myTasks" });
            });
          } else {
            this.$router.push({
              path: "correct",
              query: { id: this.data.id, activeIndex: "tasks" }
            });
            $('.loading_timer')[0].style.display = 'none';
          }
        } else if (res.data.retcode === 1 || res.data.retcode === 2) {
          this.$alert(res.data.retmsg, "登录异常", {
            confirmButtonText: "确定",
            callback: action => {
              this.clearCache();
            }
          });
        } else {
          this.$alert(res.data.retmsg, "请求失败", {
            confirmButtonText: "确定",
            callback: action => {}
          });
        }
      }).catch(err => {
        console.log(err);
      });
    },
    //暂存、提交按钮事件
    submitForm(val) {
      // 暂存
      if (val === 1) {
        this.data.temporary = 1;
        this.save(val);
      }
      // 保存
      if (val === 0) {
        this.data.temporary = 0;
        if (this.data.text) {
          this.$confirm("提交后不可更改，是否继续？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }).then(() => {
            this.save(val);
          });
        } else {
          if (this.data.resultcode === 1) {
            this.$alert("请输入图片存在的问题", {
              confirmButtonText: "确定",
              closeOnClickModal: true,
              callback: (res) => {},
            });
          }
          if (this.data.resultcode === 0) {
            this.$alert("请输入识别结果", {
              confirmButtonText: "确定",
              closeOnClickModal: true,
              callback: (res) => {},
            });
          }
        }
      }
    },
    // 暂存、提交接口
    save(val) {
      home
        .ocrSave(this.data)
        .then((res) => {
          if (res.data && res.data.retcode === 0) {
            this.$message({
              message: res.data.retmsg,
              type: "success",
              duration: 2000,
            });
            if (val === 0) {
              $('.loading_timer')[0].style.display = 'inline-block';
              this.timeDown();
            }
          } else if (res.data.retcode === 1) {
            this.$message({
              message: res.data.retmsg,
              type: "warning",
              duration: 2000,
              onClose: (res) => {
                this.clearCache();
              },
            });
          } else {
            this.$message({
              message: res.data.retmsg,
              type: "warning",
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          console.log("保存失败！");
        });
    },
    //退出按钮点击事件---清空本地储存的token
    clearCache() {
      localStorage.removeItem("token"); //清空本地缓存的token
      this.$router.push({ path: "/login" });
    },
  },
};
</script>
<style>
@keyframes ex_1 {
  0%   { left:-30px;background:#fff;border:0;}
  16%  { left:0px;background:#1890ff;}
  32%  { left:30px;background:#fff;}
  48%  { left:60px;background:#1890ff;}
  64%  { left:90px;background:#fff;}
  80%  { left:120px;background:#1890ff;}
  100% { left:150px;background:#fff;border:0;}
}
@keyframes ex_2 {
  0%   { left:0px;background:#1890ff;}
  16%  { left:30px;background:#fff;}
  32%  { left:60px;background:#1890ff;}
  48%  { left:90px;background:#fff}
  64%  { left:120px;background:#1890ff;}
  80%  { left:150px;background:#fff;border:0;}
  100% { left:-30px;background:#fff;border:0;}
}
@keyframes ex_3 {
  0%   { left:30px;background:#fff;}
  16%  { left:60px;background:#1890ff;}
  32%  { left:90px;background:#fff}
  48%  { left:120px;background:#1890ff;}
  64%  { left:150px;background:#fff;border:0;}
  80%  { left:-30px;background:#fff;border:0;}
  100% { left:0px;background:#1890ff;}
}
@keyframes ex_4 {
  0%   { left:60px;background:#1890ff;}
  16%  { left:90px;background:#fff}
  32%  { left:120px;background:#1890ff;}
  48%  { left:150px;background:#fff;border:0;}
  64%  { left:-30px;background:#fff;border:0;}
  80%  { left:0px;background:#1890ff;}
  100% { left:30px;background:#fff;}
}
@keyframes ex_5 {
  0%   { left:90px;background:#fff}
  16%   { left:120px;background:#1890ff;}
  32%  { left:150px;background:#fff;border:0;}
  48%  { left:-30px;background:#fff;border:0;}
  64%  { left:0px;background:#1890ff;}
  80% { left:30px;background:#fff;}
  100% { left:60px;background:#1890ff;}
}
@keyframes ex_6 {
  0%   { left:120px;background:#1890ff;}
  16%  { left:150px;background:#fff;border:0;}
  32%  { left:-30px;background:#fff;border:0;}
  48%  { left:0px;background:#1890ff;}
  64%  { left:30px;background:#fff;}
  80%  { left:60px;background:#1890ff;}
  100% { left:90px;background:#fff}
}
@keyframes ex_7 {
  0%   { left:150px;background:#fff;border:0;}
  16%  { left:-30px;background:#fff;border:0;}
  32%  { left:0px;background:#1890ff;}
  48%  { left:30px;background:#fff;}
  64%  { left:60px;background:#1890ff;}
  80%  { left:90px;background:#fff}
  100% { left:120px;background:#1890ff;}
}
.card_text .el-textarea__inner {
  height: 656px;
  font-size: 28px;
}
/*控制图片放大后的遮罩层的显示范围  */
.frame .el-image-viewer__wrapper {
  width: 40%;
}
/* 控制图片放大后的遮罩层大小 */
.frame .el-image-viewer__mask { 
  width: 0;
}
/* 控制图片放大后的遮罩层关闭按钮的颜色和位置 */
.frame .el-image-viewer__close {
  top: 80px;
  color: #409eff;
}
</style>
<style scoped>
.middle_cover {
  position: relative;
  top: 300px;
  text-align: center;
  width: 150px;
  height: 32px;
  line-height: 30px;
  margin: 0 auto;
  display: flex;
  overflow: hidden;
}
.move_trans {
  width:12px;
  height:12px;
  margin-left:6px;
  border: 1px solid #1890ff;
  position: absolute;
  animation-duration: 2s; 
  animation-iteration-count: infinite;
}
.trans_1{
  transform: skewX(45deg);
  border-bottom: 0;
  top: 3px;
}
.trans_2 {
  border-top: 0;
  transform: skewX(-45deg);
  top: 15px;
}
.move_1 {
  animation-name: ex_1;
}
.move_2 {
  animation-name: ex_2;
}
.move_3 {
  animation-name: ex_3;
}
.move_4 {
  animation-name: ex_4;
}
.move_5 {
  animation-name: ex_5;  
}
.move_6 {
  animation-name: ex_6;
}
.move_7 {
  animation-name: ex_7;
}
.loading_timer {
  width: 100%; height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.8);
  z-index: 100;
  display: none;
}
.loading_timer>div {
  position: absolute;
  top: 50%;left: 50%;
  margin: -250px 0 0 -300px;
  width: 600px;
  height: 500px;
  /* border: 1px solid #f00; */
}
.loading_timer > div> div:first-child {
  text-align: center;
  font-size: 120px;
  color:#3f9eff;
}
.loading_timer > div> div:nth-child(2) {
  margin-top: 20px;
  text-align: center;
  font-size: 30px;
  color:#3f9eff;
}
textarea {
  font-size: 20px;
}
.page {
  margin: 50px auto;
  height: 836px;
}
.container-fluid {
  width: 1880px;
  height: 700px;
  border: 1px solid #999;
}

*,
::after,
::before {
  box-sizing: border-box;
}
.card-header {
  display: flex;
  padding: 10px;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
}
.card-header h3 {
  font-size: 1.2rem;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.1;
  color: inherit;
  margin: 0;
}
.card-header div {
  margin-left: 30px;
  color: #f00;
}
.card-body {
  width: 900px;
  height: 100px;
  border: 1px solid #fff;
  text-align: center;
  padding: 1.25rem;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.btn_group {
  text-align: center;
  margin: 50px auto 0;
  height: 50px;
  line-height: 50px;
}
.btn_left {
  margin-right: 50px;
}
.btn {
  width: 150px;
  height: 50px;
  font-size: 1.1rem;
  letter-spacing: 0.2rem;
}
.count_down {
  width: 500px;
  height: 50px;
  margin: 0 auto;
  color: #f00;
  background: #fff;
  font-size: 25px;
  font-weight: bolder;
  line-height: 50px;
  text-align: center;
}
</style>
